const numberFormatReplace = (value) => {
  if ('.' === value) return ''
  if (/^\.\d+/.test(value)) return value.replace(/^\.\d+/, match => `0${match}`)
  if (/^\d+\.$/.test(value)) return Number(value).toFixed(0)
  return value
}

const numberFormatDigits = (fieldValue) => {
  if (!fieldValue) return fieldValue
  if (isNaN(Number(fieldValue))) return fieldValue
  return Number(fieldValue).toFixed(2)
}

const numberFormatDigitsWithZero = (fieldValue) => {
  return fieldValue === 0 ? '0.00' : numberFormatDigits(fieldValue)
}

const get2DecimalPointsWithCommas = (amount, digits = 2, useNull = false) => {
  // console.log("Number(amount)", Number(amount));
  let number = useNull === true ? null : Number(amount) || 0.00

  return number?.toLocaleString(undefined, {
    maximumFractionDigits: digits,
    minimumFractionDigits: digits
  });
}



export { numberFormatReplace, numberFormatDigits, numberFormatDigitsWithZero, get2DecimalPointsWithCommas }
